<template>
  <div>
    <ul class="groups">
      <li
        @click="setGroup(item.id)"
        :class="`${value == item.id ? 'active' : ''}`"
        v-for="item in items"
        :key="item.id"
      >
        <span>
          {{ item.title }}
        </span>
      </li>
    </ul>
    <ul v-if="value" class="groups-navigation">
      <li v-for="navigation in navigations" :key="navigation.key">
        <button
          :class="`${nav == navigation.key ? 'active' : ''}`"
          @click="setNavigate(navigation.key)"
        >
          {{ navigation.key | setText(navigation.title) }}
        </button>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      default: function () {
        return [];
      },
    },
    value: {
      default: function () {
        return null;
      },
    },
    nav: {
      default: function () {
        return null;
      },
    },
  },

  methods: {
    setGroup(id) {
      if (id == this.value) {
        return false;
      }
      this.$emit("input", id);
      this.$router.push({ query: { group_id: id } });
    },
    setNavigate(key) {
      this.$emit("navigate", key);
      this.$router.push({ query: { nav: key, group_id: this.value } });
    },
  },
  data() {
    return {
      navigations: [
        {
          key: "journal",
          title: "Журнал",
        },
        {
          key: "chat",
          title: "Онлайн-чат",
        },
        {
          key: "conference",
          title: "Конференции",
        },
        {
          key: "notifications",
          title: "Объявления",
        },
        {
          key: "timetable",
          title: "Расписание",
        },
        //    {
        //     key:'decisions',
        //     title:'Результаты доп. заданий'
        //  },
      ],
    };
  },
};
</script>

